import { toast } from 'sonner';

export const TAX_TYPES_TO_COUNTRY_CODES = {
  AF: ['n/a'],
  AX: ['n/a'],
  AL: ['n/a'],
  DZ: ['n/a'],
  AS: ['n/a'],
  AD: ['n/a'],
  AO: ['n/a'],
  AI: ['n/a'],
  AQ: ['n/a'],
  AG: ['n/a'],
  AR: ['CUIT', 'n/a'],
  AM: ['n/a'],
  AW: ['n/a'],
  AU: ['ABN', 'n/a'],
  AT: ['VAT', 'n/a'],
  AZ: ['n/a'],
  BS: ['n/a'],
  BH: ['n/a'],
  BD: ['n/a'],
  BB: ['n/a'],
  BY: ['n/a'],
  BE: ['VAT', 'n/a'],
  BZ: ['n/a'],
  BJ: ['n/a'],
  BM: ['n/a'],
  BT: ['n/a'],
  BO: ['n/a'],
  BA: ['n/a'],
  BW: ['n/a'],
  BV: ['n/a'],
  BR: ['CNPJ', 'n/a'],
  IO: ['n/a'],
  BN: ['n/a'],
  BG: ['VAT', 'n/a'],
  BF: ['n/a'],
  BI: ['n/a'],
  KH: ['n/a'],
  CM: ['n/a'],
  CA: ['BN', 'SIN', 'n/a'],
  CV: ['n/a'],
  KY: ['n/a'],
  CF: ['n/a'],
  TD: ['n/a'],
  CL: ['RUT', 'n/a'],
  CN: ['n/a'],
  CX: ['n/a'],
  CC: ['n/a'],
  CO: ['RUT', 'n/a'],
  KM: ['n/a'],
  CG: ['n/a'],
  CD: ['n/a'],
  CK: ['n/a'],
  CR: ['n/a'],
  CI: ['n/a'],
  HR: ['VAT', 'n/a'],
  CU: ['n/a'],
  CW: ['n/a'],
  CY: ['VAT', 'n/a'],
  CZ: ['VAT', 'n/a'],
  DK: ['VAT', 'n/a'],
  DJ: ['n/a'],
  DM: ['n/a'],
  DO: ['NATIONAL_ID', 'RNC', 'n/a'],
  EC: ['n/a'],
  EG: ['n/a'],
  SV: ['n/a'],
  GQ: ['n/a'],
  ER: ['n/a'],
  EE: ['VAT', 'n/a'],
  ET: ['n/a'],
  FO: ['n/a'],
  FK: ['n/a'],
  FJ: ['n/a'],
  FI: ['VAT', 'n/a'],
  FR: ['VAT', 'n/a'],
  GF: ['n/a'],
  PF: ['n/a'],
  TF: ['VAT', 'n/a'],
  GA: ['n/a'],
  GM: ['n/a'],
  GE: ['n/a'],
  DE: ['VAT', 'n/a'],
  GH: ['n/a'],
  GI: ['n/a'],
  GR: ['VAT', 'n/a'],
  GL: ['n/a'],
  GD: ['n/a'],
  GP: ['n/a'],
  GU: ['n/a'],
  GT: ['n/a'],
  GG: ['n/a'],
  GN: ['n/a'],
  GW: ['n/a'],
  GY: ['n/a'],
  HT: ['n/a'],
  HM: ['n/a'],
  HN: ['n/a'],
  HK: ['HKBR', 'n/a'],
  HU: ['VAT', 'n/a'],
  IS: ['n/a'],
  IN: ['PAN', 'n/a'],
  ID: ['n/a'],
  IR: ['n/a'],
  IQ: ['n/a'],
  IE: ['VAT', 'n/a'],
  IM: ['n/a'],
  IL: ['n/a'],
  IT: ['VAT', 'n/a'],
  JM: ['n/a'],
  JP: ['n/a'],
  JE: ['n/a'],
  JO: ['n/a'],
  KZ: ['n/a'],
  KE: ['n/a'],
  KI: ['n/a'],
  KP: ['n/a'],
  KR: ['n/a'],
  KW: ['CLN', 'n/a'],
  KG: ['n/a'],
  LA: ['n/a'],
  LV: ['VAT', 'n/a'],
  LB: ['n/a'],
  LS: ['n/a'],
  LR: ['n/a'],
  LY: ['n/a'],
  LI: ['n/a'],
  LT: ['VAT', 'n/a'],
  LU: ['VAT', 'n/a'],
  MO: ['n/a'],
  MK: ['n/a'],
  MG: ['n/a'],
  MW: ['n/a'],
  MY: ['BRNO', 'n/a'],
  MV: ['n/a'],
  ML: ['n/a'],
  MT: ['VAT', 'n/a'],
  MH: ['n/a'],
  MQ: ['n/a'],
  MR: ['n/a'],
  MU: ['n/a'],
  YT: ['n/a'],
  MX: ['RFC', 'n/a'],
  FM: ['n/a'],
  MD: ['n/a'],
  MC: ['n/a'],
  MN: ['n/a'],
  ME: ['n/a'],
  MS: ['n/a'],
  MA: ['n/a'],
  MZ: ['n/a'],
  MM: ['n/a'],
  NA: ['n/a'],
  NR: ['n/a'],
  NP: ['n/a'],
  NL: ['VAT', 'n/a'],
  NC: ['n/a'],
  NZ: ['NZBN', 'n/a'],
  NI: ['n/a'],
  NE: ['n/a'],
  NG: ['n/a'],
  NU: ['n/a'],
  NF: ['n/a'],
  MP: ['n/a'],
  NO: ['VAT', 'n/a'],
  OM: ['n/a'],
  PK: ['n/a'],
  PW: ['n/a'],
  PS: ['n/a'],
  PA: ['RUC', 'n/a'],
  PG: ['n/a'],
  PY: ['n/a'],
  PE: ['RUC', 'n/a'],
  PH: ['n/a'],
  PN: ['n/a'],
  PL: ['VAT', 'n/a'],
  PT: ['VAT', 'n/a'],
  PR: ['n/a'],
  QA: ['CL', 'n/a'],
  RE: ['n/a'],
  RO: ['VAT', 'n/a'],
  RU: ['n/a'],
  RW: ['n/a'],
  BL: ['n/a'],
  SH: ['n/a'],
  KN: ['n/a'],
  LC: ['n/a'],
  MF: ['n/a'],
  PM: ['n/a'],
  VC: ['n/a'],
  WS: ['n/a'],
  SM: ['n/a'],
  ST: ['n/a'],
  SA: ['CR', 'VAT', 'n/a'],
  SN: ['n/a'],
  RS: ['n/a'],
  SC: ['n/a'],
  SL: ['n/a'],
  SG: ['UEN', 'n/a'],
  SK: ['VAT', 'n/a'],
  SI: ['VAT', 'n/a'],
  SB: ['n/a'],
  SO: ['n/a'],
  ZA: ['VAT', 'n/a'],
  GS: ['n/a'],
  ES: ['VAT', 'n/a'],
  LK: ['n/a'],
  SD: ['n/a'],
  SR: ['n/a'],
  SJ: ['n/a'],
  SZ: ['n/a'],
  SE: ['VAT', 'n/a'],
  CH: ['VAT', 'n/a'],
  SY: ['n/a'],
  TW: ['n/a'],
  TJ: ['n/a'],
  TZ: ['n/a'],
  TH: ['n/a'],
  TL: ['n/a'],
  TG: ['n/a'],
  TK: ['n/a'],
  TO: ['n/a'],
  TT: ['n/a'],
  TN: ['n/a'],
  TR: ['VAT', 'n/a'],
  TM: ['n/a'],
  TC: ['n/a'],
  TV: ['n/a'],
  UG: ['n/a'],
  UA: ['EDRPOU', 'VAT', 'n/a'],
  AE: ['VAT', 'n/a'],
  GB: ['VAT', 'n/a'],
  US: ['EIN', 'SSN', 'n/a'],
  UM: ['EIN', 'SSN', 'n/a'],
  UY: ['n/a'],
  UZ: ['n/a'],
  VU: ['n/a'],
  VA: ['n/a'],
  VE: ['n/a'],
  VN: ['n/a'],
  VG: ['n/a'],
  VI: ['n/a'],
  WF: ['n/a'],
  EH: ['n/a'],
  YE: ['n/a'],
  ZM: ['n/a'],
  ZW: ['n/a'],
};

export const getTaxTypeOptionsByCountryCode = (countryCode: string) => {
  const taxTypes =
    TAX_TYPES_TO_COUNTRY_CODES[countryCode as keyof typeof TAX_TYPES_TO_COUNTRY_CODES];

  if (!taxTypes) {
    console.error('No tax types found for country code', countryCode);
    toast.error('Something went wrong, please try again or contact support');

    return [];
  }

  return taxTypes.map(taxType => ({
    value: taxType,
    label: taxType,
  }));
};
